import * as CryptoJS from "crypto-js";

/**
 * Decryption method that corresponds to the C# encryptor.
 *
 * From https://stackoverflow.com/a/22831964
 */
export function decrypt(key, salt, iv, encrypted) {
  try {
    var ivBytes = CryptoJS.enc.Hex.parse(iv);
    var keyBytes = CryptoJS.enc.Utf8.parse(key);
    var saltBytes = CryptoJS.enc.Utf8.parse(salt);
    var key128Bits1000Iterations = CryptoJS.PBKDF2(
      keyBytes.toString(CryptoJS.enc.Utf8),
      saltBytes,
      { keySize: 128 / 32, iterations: 1000 },
    );
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encrypted),
    });

    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key128Bits1000Iterations,
      {
        mode: CryptoJS.mode.CBC,
        iv: ivBytes,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    const text = decrypted.toString(CryptoJS.enc.Utf8);

    return text;
  } catch (err) {
    return undefined;
  }
}
